export function legacyFinancialFileStatus(file = {}) {
  const status = typeof file.status === 'string' ? file.status.toUpperCase() : '';
  if (file.processingErrorCode === 'REPORTED_INCOME_REVIEW_REQUIRED') return {
    label: 'Review required', active: false,
    reason: 'Verify the reported income figures in the original document before reprocessing. The original file is retained and financial values were not replaced.',
  };
  if (['FAILED', 'ERROR'].includes(status)) return {
    label: 'Processing failed', active: false,
    reason: 'Check the original document and refresh its status before trying again.',
  };
  // Older successful records retained PROCESSING even after processed became true.
  if (file.processed === true || status === 'PROCESSED') return { label: 'Processed', active: false, reason: '' };
  if (status === 'PROCESSING') return { label: 'Processing', active: true, reason: 'Refresh file status to check for a result.' };
  if (status === 'QUEUED' || (!status && file.processed === false)) return { label: 'Awaiting processing', active: true, reason: 'Refresh file status to check for a result.' };
  return { label: 'Status unavailable', active: false, reason: 'Refresh file status to check the saved processing result.' };
}

export const legacyFinancialFileFingerprint = file => JSON.stringify([
  file?.status, file?.processed, file?.processedAt,
  file?.processingErrorCode, file?.processingError,
]);
